import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { uiKitsKeys } from './uiKitsKeys';
import { IUIKitsQueryParams } from './useQueryUIKits';

export interface IUpsertUIKitParams {
  title: string;
  thumbnail: string;
  fontFamily?: string;
  bodyFontSize?: number;
  titleFontSize?: number;
  textColor?: string;
  buttonColor?: string;
  bodyBackgroundColor?: string;
  headerBackgroundColor?: string;
  footerBackgroundColor?: string;
}

const createUIKit = async (payload: IUpsertUIKitParams) => {
  return await EXPRESS_API.post(`/superadmin/uikit`, payload);
};

export const useCreateUIKitMutation = (
  handleGoBack: () => void,
  params?: IUIKitsQueryParams
) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(createUIKit, {
    onSuccess: () => {
      successToast({ title: 'UI Kit has been successfully created!' });
      if (params) {
        queryClient.refetchQueries(uiKitsKeys.list(params));
      }
      handleGoBack();
    },
    onError: error =>
      showError(error || 'An error occured while creating the UI Kit!'),
  });
};
